// src/icons/Explorer.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Explorer() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.90625 6.38889L8.21689 6.09345L7.76885 7.13889H8.90625V6.38889ZM11.3229 0.75L12.0123 1.04544C12.149 0.726338 12.0489 0.355085 11.7703 0.148013C11.4916 -0.0590584 11.1072 -0.0478189 10.8412 0.175182L11.3229 0.75ZM0.75 9.61111L0.268248 9.03629C0.0265337 9.23887 -0.0626239 9.57103 0.0451549 9.86742C0.152934 10.1638 0.43462 10.3611 0.75 10.3611L0.75 9.61111ZM7.09375 9.61111L7.78311 9.90655L8.23115 8.86111H7.09375V9.61111ZM4.67708 15.25L3.98772 14.9546C3.85097 15.2737 3.95109 15.6449 4.22974 15.852C4.5084 16.0591 4.89275 16.0478 5.15884 15.8248L4.67708 15.25ZM15.25 6.38889L15.7318 6.96371C15.9735 6.76113 16.0626 6.42897 15.9548 6.13258C15.8471 5.83619 15.5654 5.63889 15.25 5.63889V6.38889ZM9.59561 6.68433L12.0123 1.04544L10.6336 0.454561L8.21689 6.09345L9.59561 6.68433ZM10.8412 0.175182L0.268248 9.03629L1.23175 10.1859L11.8047 1.32482L10.8412 0.175182ZM0.75 10.3611H7.09375V8.86111H0.75V10.3611ZM6.40439 9.31567L3.98772 14.9546L5.36644 15.5454L7.78311 9.90655L6.40439 9.31567ZM5.15884 15.8248L15.7318 6.96371L14.7682 5.81407L4.19533 14.6752L5.15884 15.8248ZM15.25 5.63889H8.90625V7.13889H15.25V5.63889Z",
          fill: "currentColor"
        }
      )
    }
  );
}

export {
  Explorer
};
